// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ra-5";
export var filledCircle = "_ra-4";
export var historyEntry = "_ra-3";
export var messageSideLeft = "_ra-1";
export var messageSideRight = "_ra-2";
export var orderTrackingCarouselWrapper = "_ra-6";
export var orderTrackingInfoContainer = "_ra-0";